<template>
  <div>
    <img :src="useSrc" :alt="name" class="ball">
  </div>  
</template>

<script>

  export default {
    name: 'ClubIcon',
    props: ['name','shield','ball'],
    computed: {
      useSrc () {
        if(this.ball){
          var isAShirt = this.ball.indexOf('shirt') > -1;
          if(isAShirt){
            return 'https://fanhive-club-shields-placeholder.s3.eu-west-2.amazonaws.com/' + this.ball.replace('-shirt', '') + '.png';
          } else {
            return 'https://fanhive-balls.s3.eu-west-2.amazonaws.com/ball-' + this.ball + '.png';
          }
        } else {
          return this.shield;
        }
      }
    }
  }
</script>
